import { render, staticRenderFns } from "./CartRelatedProducts.vue?vue&type=template&id=704f53f8&scoped=true&"
import script from "./CartRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./CartRelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./CartRelatedProducts.vue?vue&type=style&index=0&id=704f53f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f53f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiScrollableSlider: require('/app/components/UI/UiScrollableSlider.vue').default})
